import { render, staticRenderFns } from "./next-game.vue?vue&type=template&id=5bc9826f&scoped=true&"
import script from "./next-game.vue?vue&type=script&lang=js&"
export * from "./next-game.vue?vue&type=script&lang=js&"
import style0 from "./next-game.vue?vue&type=style&index=0&id=5bc9826f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc9826f",
  null
  
)

export default component.exports